
import type { SkillNode } from '../types';

export function googleQueryUrl(q: string){
  const url = new URL('https://www.google.com/search');
  url.searchParams.set('q', q);
  return url.toString();
}

export function firstGoogleLink(node: SkillNode): string {
  const explicit = (node.links ?? []).find(l => l.type === 'google' && l.query);
  const q = explicit?.query || `pickleball ${node.name} drills`;
  return googleQueryUrl(q);
}
